// extracted by mini-css-extract-plugin
export var animate = "Icon-module--animate--43978";
export var icon = "Icon-module--icon--9836e";